module.exports = __webpack_public_path__ + "static/unitypoint-health-908fe900a7f475d81974abbcb4bbfb04.png";